import moment from 'moment';
import React from 'react';
import BaseInputFilter from './baseInputFilter.jsx';

export default class GridDateFilter extends BaseInputFilter {
    constructor(args) {
        super(args);

        this.state.displayFormat = "DD.MM.YYYY";
        this.state.innerFormat = "YYYY-MM-DDT00:00:00";
        this.state.initOperation = "equals";
        this.state.operations = [
            {
                "key": "equals",
                "name": "Равно"
            },
            {
                "key": "not-equals",
                "name": "Не равно"
            },
            {
                "key": "greater",
                "name": "Больше"
            },
            {
                "key": "greater-equal",
                "name": "Больше или равно"
            },
            {
                "key": "less",
                "name": "Меньше"
            },
            {
                "key": "less-equal",
                "name": "Меньше или равно"
            },
            {
                "key": "between",
                "name": "Между"
            }
        ];

        this.onOperationChanged = () => {
            this.setDatePicker();
        };
    }

    componentDidMount() {
        this.setDatePicker();
    }

    setDatePicker() {
        let operation = this.state.value ? this.state.value.operation : this.state.initOperation;
        $('#' + this.state.column.fieldName + 'DateFilterInput').daterangepicker(
            {
                "singleDatePicker": operation !== 'between',
                "timePicker": false,
                "autoUpdateInput": false,
                "drops": "down",
                "locale": {
                    "format": this.state.displayFormat,
                    "applyLabel": "Применить",
                    "cancelLabel": "Отмена",
                    "fromLabel": "С",
                    "toLabel": "По",
                    "weekLabel": "Н",
                    "daysOfWeek": [
                        "Вс",
                        "Пн",
                        "Вт",
                        "Ср",
                        "Чт",
                        "Пт",
                        "Сб"
                    ],
                    "monthNames": [
                        "Январь",
                        "Февраль",
                        "Март",
                        "Апрель",
                        "Май",
                        "Июнь",
                        "Июль",
                        "Август",
                        "Сентябрь",
                        "Октябрь",
                        "Ноябрь",
                        "Декабрь"
                    ],
                    "firstDay": 1
                }
            },
            (start, end, label) => {
                this.ensureFilterValue();
                this.state.value.value = start.format(this.state.innerFormat) + ',' + end.format(this.state.innerFormat);
                this.applyFilterChanges();
            });
    }

    ensureFilterValue() {
        if (!this.state.value) {
            let today = moment().format(this.state.innerFormat);
            this.state.value = {
                fieldName: this.state.column.fieldName,
                operation: this.state.initOperation,
                value: today + ',' + today
            };
        }
    }

    render() {
        let operations = this.renderOperationsList();
        let filterControlId = this.state.column.fieldName + 'DateFilterInput';
        let currentOperation = this.state.value ? this.state.value.operation : "default";

        let filterValue = "";
        if (this.state.value) {
            let dates = this.state.value.value.split(',');
            if (dates.length < 2) {
                dates.push(dates[0]);
            }
            if (currentOperation === "between") {
                filterValue = moment(dates[0]).format(this.state.displayFormat) + ' - ' + moment(dates[1]).format(this.state.displayFormat);
            } else {
                filterValue = moment(dates[0]).format(this.state.displayFormat);
            }
        }
        if (!this.state.value) {
            this.setDatePicker();
        }

        return (
            <div className="input-group">
                {operations}
                <input type="text"
                    className="form-control"
                    id={filterControlId}
                    value={filterValue}
                    disabled={this.props.disabled}
                />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./App/grid/filter/dateFilter.jsx